<template>
  <el-drawer
    show-close
    visible
    :size="800"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    append-to-body
  >
    <div class="drawer-main">
      <Main
        ref="main"
        :disabled="disabled"
        :isConfirmEdit="isConfirmEdit"
        :isCopy="isCopy"
        :amzControlParamsCode="amzControlParamsCode"
        @close="close"
        @reload="$emit('reload')"
      />
    </div>
    <div class="drawer-footer">
      <el-button size="small" v-if="!disabled" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    type: { type: String, default: '' },
    amzControlParamsCode: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l('dialog_title_edit') || '编辑亚马逊市场控价参数',
        confirmEdit: this.$l('dialog_title_edit') || '编辑亚马逊市场控价参数',
        add: this.$l('dialog_title_add') || '新增亚马逊市场控价参数',
        detail: this.$l('dialog_title_detail') || '亚马逊市场控价参数详情',
        copy: this.$l('dialog_title_add') || '新增亚马逊市场控价参数',
      },
    }
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
    isCopy() {
      return this.type === 'copy'
    },
    disabled() {
      return this.type === 'detail'
    },
    isConfirmEdit() {
      return this.type === 'confirmEdit'
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 20px 20px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  margin-bottom: 10px !important;
}
::v-deep {
  .el-drawer__header {
    font-size: 14px !important;
  }
}
</style>
